import { AccordionController } from "./comp-accordion"

/**
 * FLOWステップのアコーディオンの初期化
 *
 * @description 共通のAccordionControllerを使う。
 *              トリガーに .acc-sp-only が付いているのでSP（〜1024px）でのみ開閉し、
 *              PCでは本文・写真が常に開いた状態になる。
 *              排他モードにはしない（複数同時に開ける）。
 */
export const flowAccordion = new AccordionController(".flow")
